package dev.lingvo.shared.screenshots.render

/** Xorshift32 makes a fresh 128 by 128 monochrome tile, independent of platform random implementations. */
fun noiseTile(seed: Int): ByteArray {
    var state = if (seed == 0) 0x6D2B79F5 else seed
    return ByteArray(128 * 128) {
        state = state xor (state shl 13)
        state = state xor (state ushr 17)
        state = state xor (state shl 5)
        state.toByte()
    }
}
